import {getRequest, postRequest} from "redux-request-middleware";
import {insuranceUrl} from "config";

export enum Actions {
    REQUEST_PROFILE_FOR_INSURANCE = "REQUEST_PROFILE_FOR_INSURANCE",
    SAVE_PROFILE_FOR_INSURANCE = "SAVE_PROFILE_FOR_INSURANCE",
    REQUEST_INSURANCE_PRODUCTS = "REQUEST_INSURANCE_PRODUCTS",
    REQUEST_USER_INSURANCE_ORDERS = "REQUEST_USER_INSURANCE_ORDERS",
    REQUEST_SUBSCRIBE_INSURANCE = "REQUEST_SUBSCRIBE_INSURANCE",
    REQUEST_INSURANCE_DOCUMENT = "REQUEST_INSURANCE_DOCUMENT",
    CLEAR_INSURANCE_DOC = "CLEAR_INSURANCE_DOC",
    INSURANCE_PURCHASED = "INSURANCE_PURCHASED",
    SELECTED_SUB_PRODUCT = "SELECTED_SUB_PRODUCT",
    SELECTED_PRODUCT = "SELECTED_PRODUCT",
    CLEAR_DOWNLOAD_POLICY_MSG = "CLEAR_DOWNLOAD_POLICY_MSG",
    CLEAR_SUBSCRIPTION_ERROR = "CLEAR_SUBSCRIPTION_ERROR",
    PRODUCT_FROM_SESSION_STORAGE = "PRODUCT_FROM_SESSION_STORAGE",
    SAVE_USER_INFO = "SAVE_USER_INFO",
    CLEAR_SELECTED_INFO = "CLEAR_SELECTED_INFO",
    SET_INSURANCE_LOADING = "SET_INSURANCE_LOADING",
    SELECTED_COVER_TYPE = "SELECTED_COVER_TYPE",
}

export function getInsuranceProducts() {
    return (dispatch) => {
        dispatch(
            getRequest(
                Actions.REQUEST_INSURANCE_PRODUCTS,
                `/products`,
                null,
                null,
                null,
                insuranceUrl,
            ),
        );
    };
}

export function getUserOrders(orderId: string = null) {
    let url = "/order";
    if (orderId) {
        url += `?orderId=${orderId}`;
    }
    return (dispatch) => {
      dispatch(
          getRequest(
                Actions.REQUEST_USER_INSURANCE_ORDERS,
                url,
                null,
                null,
                null,
                insuranceUrl,
          ),
      );
    };
}

export function subscribeInsurance(userDetails: any) {
    return (dispatch) => {
        dispatch(
            postRequest(
                Actions.REQUEST_SUBSCRIBE_INSURANCE,
                `/order`,
                userDetails,
                null,
                null,
                null,
                insuranceUrl,
            ),
        );
    };
}

export function clearInsuranceBase64Doc() {
    return { type: Actions.CLEAR_INSURANCE_DOC};
}
export function insurancePurchased() {
    return { type: Actions.INSURANCE_PURCHASED};
}
export function saveSelectedSubProduct(subProduct: string) {
    return { type: Actions.SELECTED_SUB_PRODUCT, body: {subProduct}};
}
export function saveSelectedCoverType(isIndividualSelected: boolean) {
    return { type: Actions.SELECTED_COVER_TYPE, body: {isIndividualSelected}};
}
export function saveSelectedProductIndex(productIndex: number) {
    return { type: Actions.SELECTED_PRODUCT, body: {productIndex}};
}
export function clearDownloadPolicyMsg() {
    return { type: Actions.CLEAR_DOWNLOAD_POLICY_MSG};
}
export function clearSubscriptionError() {
    return {type: Actions.CLEAR_SUBSCRIPTION_ERROR};
}
export function setInsuranceProductsFromSessionStorage(insuranceState: any) {
    return { type: Actions.PRODUCT_FROM_SESSION_STORAGE, body: {insuranceState}};
}
export function saveUserInfo(userDetails: any) {
    return { type: Actions.SAVE_USER_INFO, body: userDetails};
}

export function clearSelectedInfo() {
    return {type: Actions.CLEAR_SELECTED_INFO};
}

export function setLoaderActive(isActive: boolean) {
    return {type: Actions.SET_INSURANCE_LOADING, body: isActive};
}
